// C2 — loads images marked data-c2-lazy (snippets/c2-lazy.liquid) when they come within one screen height of
// the screen (and one screen width ahead sideways, for carousels), so visitors don't see empty photo boxes. Watches for images added later (animal switch, theme editor).
// Also videos marked data-c2-lazy-video (C2 · Image + text): the poster loads at one screen, the video file only at half a
// screen (it's ~1.5 MB, so it mustn't compete with the page's first photos), then it plays silently in a loop.
const PROP = "__c2lazy";
if (!window[PROP]) {
  window[PROP] = true;
  const load = (img) => {
    if (img.tagName === "VIDEO") {
      if (img.dataset.c2Poster) { img.poster = img.dataset.c2Poster; img.removeAttribute("data-c2-poster"); }
      if (vio && !img.__c2near) { vio.observe(img); return; }
      img.removeAttribute("data-c2-lazy-video");
      img.muted = true;
      img.preload = "auto";
      img.autoplay = true;
      img.play?.()?.catch?.(() => {});
      return;
    }
    if (img.dataset.c2Srcset) img.srcset = img.dataset.c2Srcset;
    if (img.dataset.c2Src) img.src = img.dataset.c2Src;
    img.removeAttribute("data-c2-lazy");
  };
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { io.unobserve(e.target); load(e.target); }
      }), { rootMargin: "100% 100%" })
    : null;
  const vio = io
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { vio.unobserve(e.target); e.target.__c2near = true; load(e.target); }
      }), { rootMargin: "50% 100%" })
    : null;
  const SEL = "img[data-c2-lazy], video[data-c2-lazy-video]";
  const scan = (root) => root.querySelectorAll?.(SEL).forEach((img) => (io ? io.observe(img) : load(img)));
  scan(document);
  new MutationObserver((list) => list.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && (n.matches?.(SEL) ? (io ? io.observe(n) : load(n)) : scan(n)))))
    .observe(document.documentElement, { childList: true, subtree: true });
}
